import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { Box, Header } from '~/shared/ui'
import { CALENDAR, PeriodFigures } from '~/team_tools/dashboard/statistic/figures'
import { formatCount, usePeopleSeries } from './people_series'

/** Closed beta: accounts let in per period, with the requests made beside
 *  them, charted by day. All time is everybody let in so far, with the
 *  requests still waiting. */
export const AccountsBetaUserCount = () => {
    const accepted = usePeopleSeries('beta_accepted')
    const requested = usePeopleSeries('beta_requests')
    const [waiting, setWaiting] = useState<number>()
    const [users, setUsers] = useState<number>()

    useEffect(() => {
        jsonrpc('statistic.accounts.beta_users_count').then((res) => {
            const { requests, users } = res.result || {}
            setWaiting(requests)
            setUsers(users)
        })
    }, [])

    return (
        <Box className='w-full text-center'>
            <Header>Beta Users</Header>
            <PeriodFigures
                periods={CALENDAR}
                loading={accepted.counts.total === undefined}
                value={(period) => formatCount(accepted.counts[period])}
                note={(period) =>
                    requested.counts[period] !== undefined
                        ? `let in, ${formatCount(requested.counts[period])} requested`
                        : undefined
                }
                total={{
                    label: 'All time',
                    value: formatCount(users),
                    note: waiting !== undefined ? `let in, ${formatCount(waiting)} requests waiting` : undefined,
                    as: <NavLink to='/team-tools/accounts/users?beta_tester__in=true' className='hover:outline' />,
                }}
                chart={{
                    lines: [
                        { label: 'Let in', colour: 'rgb(34, 197, 94)', history: accepted.history },
                        { label: 'Requested', colour: '#eab308', history: requested.history },
                    ],
                }}
            />
        </Box>
    )
}
